var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarsRaffleStart = function SvgStarsRaffleStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 143,
    fill: "none",
    viewBox: "0 0 79 143"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_7549_10165)",
    fillOpacity: 0.47,
    fillRule: "evenodd",
    d: "m39.636 8.474-2.593 2.651a.583.583 0 0 1-.984-.276l-.834-3.613-2.65-2.592a.583.583 0 0 1 .276-.984l3.613-.834 2.592-2.65a.582.582 0 0 1 .984.276l.834 3.612 2.65 2.593a.583.583 0 0 1-.276.984zM11.878 55.903l-3.954 6.515a1.198 1.198 0 0 1-2.1-.095L2.472 55.48l-6.515-3.955a1.198 1.198 0 0 1 .094-2.099l6.845-3.352 3.954-6.516a1.197 1.197 0 0 1 2.1.095l3.352 6.845 6.515 3.954a1.197 1.197 0 0 1-.094 2.1zm10.21 75.912-13.19 10.412a2.64 2.64 0 0 1-4.266-1.813l-1.651-16.725-10.413-13.191a2.643 2.643 0 0 1 1.813-4.265l16.725-1.651 13.192-10.413a2.64 2.64 0 0 1 4.265 1.814l1.651 16.725 10.413 13.191a2.64 2.64 0 0 1-1.814 4.264zm46.665-38.852 4.19-2.16 4.692.44a.74.74 0 0 0 .727-1.077l-2.16-4.189.44-4.692a.741.741 0 0 0-1.077-.728l-4.189 2.16-4.693-.44a.74.74 0 0 0-.727 1.077l2.16 4.189-.44 4.693a.74.74 0 0 0 1.077.727",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7549_10165",
    x1: 86.5,
    x2: -49.377,
    y1: -15,
    y2: 47.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AEE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009D34",
    stopOpacity: 0
  })))));
};
export default SvgStarsRaffleStart;